<template>
  <div>
    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <label for="">{{ $t('checkIn') }}</label>
          <date-picker mode="range"
                       :input-props='{
                         class: "form-control",
                         readonly: true,
                         style: "background-color:white;"
                       }'
                       :firstDayOfWeek="2"
                       @input="changeDate"
                       v-model="checkIn"
                       :min-date='minDate'
                       :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }">
                       >
            <input slot-scope="{ inputProps, inputEvents, isDragging }"
                   class="form-control"
                   v-bind="inputProps"
                   v-on="inputEvents"
                   >
          </date-picker>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="">{{ $t('checkOut') }}</label>
          <date-picker mode="range"
                       :input-props='{
                         class: "form-control",
                         readonly: true,
                         style: "background-color:white;"
                       }'
                       :firstDayOfWeek="2"
                       v-model="checkOut"
                       @input="changeDate"
                       :min-date='minDate'
                       >
            <input slot-scope="{ inputProps, inputEvents, isDragging }"
                  class="form-control"
                  v-bind="inputProps"
                  v-on="inputEvents"
                  >
          </date-picker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import moment from 'moment';

export default  {
  name: 'CheckIn',
  data: () => ({
    checkIn: null,
    checkOut: null,
    minDate: moment().subtract(1, 'year').startOf('year').toDate()
  }),
  components: {
    DatePicker
  },
  created() {

    if(this.$route.query.checkInStart || this.$route.query.checkInEnd){

      this.checkIn = {};

      if(this.$route.query.checkInStart){
        this.checkIn.start = moment(this.$route.query.checkInStart.split('_')[0]).toDate();
      }
      if(this.$route.query.checkInEnd){
        this.checkIn.end = moment(this.$route.query.checkInEnd.split('_')[0]).toDate();
      }
    }

    if(this.$route.query.checkOutStart || this.$route.query.checkOutEnd){

      this.checkOut = {};

      if(this.$route.query.checkOutStart){
        this.checkOut.start = moment(this.$route.query.checkOutStart.split('_')[0]).toDate();
      }
      if(this.$route.query.checkOutEnd){
        this.checkOut.end = moment(this.$route.query.checkOutEnd.split('_')[0]).toDate();
      }
    }
  },
  methods: {
    changeDate: function(e){
      let query = {};
      if(this.checkIn){
        if(this.checkIn.start){
          query.checkInStart = moment(this.checkIn.start).format('YYYY-MM-DD');
        }
        if(this.checkIn.end){
          query.checkInEnd = moment(this.checkIn.end).format('YYYY-MM-DD');
        }
      }

      if(this.checkOut){
        if(this.checkOut.start){
          query.checkOutStart = moment(this.checkOut.start).format('YYYY-MM-DD');
        }
        if(this.checkOut.end){
          query.checkOutEnd = moment(this.checkOut.end).format('YYYY-MM-DD');
        }
      }

      this.$router.push({name: this.$route.name, params: {property: this.$route.params.property, room: this.$route.params.room}, query: query })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "checkIn": "Check Out",
    "checkOut": "Check In"
  },
  "sl": {
    "checkIn": "Prihod",
    "checkOut": "Odhod"
  }
}
</i18n>
